import React from 'react';
import classnames from 'classnames';
import * as _ from 'lodash';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text18 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    rightsPermitCompanyMeshakenet,
    rightsPermitRami,
    rightsPermitOther
  } = context.data.pdfData;

  const showText = _.some([
    rightsPermitCompanyMeshakenet,
    rightsPermitRami,
    rightsPermitOther
  ]);

  return (
    <div ref={ref}>
      {showText && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.underline)}>זכויות אחרות (חוזיות / זיקות הנאה / וכיוצ"ב):</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text18;
